export const fixNumber = (num: number, fraction: number) => {
  return +num.toFixed(fraction);
};
